import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment.development';

export interface CrearCedulaRequest {
  tipoCedula: string;
  cedula: number;
}

export interface ActualizarCedulaRequest {
  tipoCedula?: string;
  cedula?: number;
}

@Injectable({
  providedIn: 'root',
})
export class CedulaService {
  private apiUrl = `${environment.apiUrl}/cedula-profesional`;

  constructor(private http: HttpClient) {}

  crearCedula(cedula: CrearCedulaRequest): Observable<any> {
    return this.http.post<any>(this.apiUrl, cedula);
  }

  actualizarCedula(cedulaId: string | number, cedula: ActualizarCedulaRequest): Observable<any> {
    return this.http.patch<any>(`${this.apiUrl}/${cedulaId}`, cedula);
  }

  eliminarCedula(cedulaId: string | number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${cedulaId}`);
  }
}
